export const environment = {
  appName: 'AVIDEA-ERP',
  landingPage: '/dashboard',
  logo: '/assets/images/logo-horizontale.png',
  logoWhite: '/assets/images/logo_avidea.png',
  compact: '/assets/images/logo_avidea.png',
  production: true,
  apiBaseUrl: location.origin + '/api',
  socketBaseUrl: 'wss://' + location.host + '/websocket/stomp',
};
